import { getData, postData } from '../../../shared/api/core';

export const getAggregatedStock = (params) =>
  getData(`/stock/aggregatedStock?${new URLSearchParams(params).toString()}`);

export const getStockSummary = (params) =>
  getData(
    `/stock/aggregatedStock/summary?${new URLSearchParams(params).toString()}`
  );

export const getStockDetails = (params) =>
  getData(
    `/stock/aggregatedStock/details?${new URLSearchParams(params).toString()}`
  );

export const getStockCombinations = () => getData(`/stock/combinations`);

export const getStockCombinationBreakdown = (params) =>
  getData(
    `/stock/aggregatedStock/breakdown?${new URLSearchParams(params).toString()}`
  );

export const addStock = (data) => postData(`/stock/with-holds`, data);

export const recalculateStock = ({ keys, isZeroOutStaleStocks = false }) =>
  postData(`/stock/stock-recalculation`, { keys, isZeroOutStaleStocks });
